import React, { Component } from 'react'
import { firAuth } from '../service/firebase'
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom'
import 'antd/dist/antd.css'

import Login        from '../pages/login/Login'
import Dashboard    from '../pages/dashboard/Dashboard'
import Privacy      from '../pages/privacy/Privacy'

import EventService from '../service/event'


function PublicRoute ({component: Component, userAccess, ...rest}) {
    return (
        <Route
            {...rest}
            render={(props) => {
                if(userAccess === false){
                    return <Component {...props} />
                } else {
                    return <Redirect to='/dashboard' />
                }
            }}
        />
    )
}

function PrivateRoute ({component: Component, userAccess, ...rest}) {
    return (
        <Route
            {...rest}
            render={(props) => {
                if(userAccess === true) {
                    return <Component {...props} />
                } else {
                    return <Redirect to={{pathname: '/', state: {from: props.location}}} />
                }
            }}
        />
    )
}


class App extends Component {
  
    constructor() {
        super()

        this.state = {
            userAuth: false,
        }

        EventService.on('user', () => {
            this.checkState()
        })
    }

    checkState() {
        let user = firAuth.currentUser
        if(user && user.uid) {
            this.setState({userAuth: true})
        } else {
            this.setState({userAuth: false})
        }
    }
    
    render() {
        return (
            <Router>
                <div className="App">
                    <Route exact path='/privacy' component={(props) => (<Privacy {...props}/>)} />
                    <PublicRoute userAccess={this.state.userAuth} exact path='/' component={() => (<Login />)} />
                    <PrivateRoute userAccess={this.state.userAuth} path='/dashboard' component={(props) => (<Dashboard {...props} />)} />
                </div>
            </Router>
        )
    }
}

export default App
